import { StyledIcon } from './IconStroke.styled';

interface IIconStrokeProps {
	src: string;
	width?: number;
	height?: number;
	opacity?: number;
	style?: React.CSSProperties;
}

const IconStroke: React.FC<IIconStrokeProps> = ({
	src,
	width,
	height,
	opacity,
	style,
}: IIconStrokeProps) => {
	return (
		<StyledIcon
			src={src}
			width={width}
			height={height}
			style={style}
			$opacity={opacity}
		/>
	);
};

export { IconStroke };
